export enum IpreoAccountAuthorityEnvCode {
  Staging,
  Production
}

export enum IhsSamAuthorityEnvCode {
  Staging,
  Production
}

export enum OktaAuthorityEnvCode {
  Staging,
  Production
}

export interface AuthClientSettings {
  billfoldAuthSettings: BillfoldAuthClientSettings;
  ihsSamSettings: IhsSamClientSettings;
  oktaSettings: OktaClientSettings;
}

export interface BillfoldAuthClientSettings {
  clientId: string;
  authority: IpreoAccountAuthorityEnvCode;
  scope: string[];
  baseRedirectionPath: string;
}

export interface IhsSamClientSettings {
  clientId: string;
  authority: IhsSamAuthorityEnvCode;
  scope: string[];
  baseRedirectionPath: string;
}

export interface OktaClientSettings {
  clientId: string;
  authority: OktaAuthorityEnvCode;
  scope: string[];
  baseRedirectionPath: string;
}
